export default {
    pregnancyMethod: 'روش بارداری',
    pregnancyMethodTitle: 'عنوان',
    pregnancyMethodStatus: 'وضعیت',
    pregnancyMethods: 'مدیریت روش‌های بارداری',
    editPregnancyMethod: 'ویرایش روش بارداری',
    addPregnancyMethod: 'روش بارداری جدید',
}